import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import { FrameType } from '../types/templateModel'

export type FrameOptions = FrameType | 'none'

export const useTranslateFrameTypes = () => {
  const translate = useTranslate()
  const frameOptionsWithTranslations: Record<FrameOptions, string> = useMemo(
    () =>
      ({
        [FrameType.RangedValueFrame]: translate(
          'enum.FrameType.RangedValueFrame',
        ),
        [FrameType.EnumeratedValueFrame]: translate(
          'enum.FrameType.EnumeratedValueFrame',
        ),
        none: translate('none'),
      }) as const,
    [translate],
  )

  return frameOptionsWithTranslations
}
